import type { ReactElement } from 'react';

import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import { OtherCategory } from '@/types/categories/categories';

export type OtherCategoryCardProps = {
    category: OtherCategory;
};

export const OtherCategoryCard = ({ category }: OtherCategoryCardProps): ReactElement => {
    return (
        <article className="-mr-[3px] mb-lg w-[286px] [&_a:hover]:underline [&_a]:text-base [&_a]:no-underline">
            <H5>{category.title}</H5>
            <hr className="mt-xs" />
            {category.subCategories.map((subCategory) => (
                <div
                    className="mx-auto my-xs flex flex-wrap [&_a]:text-text-primary"
                    key={subCategory.title}
                >
                    <Link
                        href={subCategory.pageUrl}
                        target="_blank"
                    >
                        {subCategory.title}
                    </Link>
                </div>
            ))}
            <Link
                href={category.pageUrl}
                target="_blank"
            >
                <FormattedMessage id="discoverPage.otherCategories.viewAllItems" />
            </Link>
        </article>
    );
};
